module.exports = __webpack_public_path__ + "static/media/Autolinker.4c1d5e8b.ttf";